import { AppActions } from './enum';
import { AppState } from './interface';
import { OverlayContent } from '../../enums/elementId';
import { Address, AvcResult, JarvisProduct } from '@vfde-sails/avc-core';
import { HomesPassedType } from 'app/enums/product';

export const initStore = (payload: Partial<AppState>) => ({
    type: AppActions.INIT_STORE,
    payload,
} as const);

export const setLoading = (loading: boolean = true) => ({
    type: AppActions.SET_LOADING,
    loading,
} as const);

export const setAddress = (address: Address) => ({
    type: AppActions.SET_ADDRESS,
    address,
} as const);

export const deleteAddress = () => ({
    type: AppActions.DELETE_ADDRESS,
} as const);

export const resetTariffsToPreAvc = () => ({
    type: AppActions.RESET_TARIFFS_TO_PRE_AVC,
} as const);

export const setError = (error: Error) => ({
    type: AppActions.SET_ERROR,
    error,
} as const);

export const setTariffs = (tariffs: JarvisProduct[], isInit = false) => ({
    type: AppActions.SET_TARIFFS,
    tariffs,
    isInit,
} as const);

export const setSelectedTariffId = (id: string) => ({
    type: AppActions.SET_SELECTED_TARIFF_ID,
    id,
} as const);

export const setAvcResult = (result?: AvcResult) => ({
    type: AppActions.SET_AVC_RESULT,
    result,
} as const);

export const overlayLoaded = () => ({
    type: AppActions.SET_OVERLAY_LOADED,
} as const);

export const openOverlay = (overlayWrapper: OverlayContent) => ({
    type: AppActions.OPEN_OVERLAY,
    overlayWrapper,
} as const);

export const closeOverlay = () => ({
    type: AppActions.CLOSE_OVERLAY,
} as const);

export const setActiveOverlay = (activeOverlay: OverlayContent) => ({
    type: AppActions.SET_ACTIVE_OVERLAY,
    activeOverlay,
} as const);

export const setHomesPassed = (homesPassed?: HomesPassedType) => ({
    type: AppActions.SET_HOMES_PASSED,
    homesPassed,
} as const);

export type Actions = ReturnType<typeof initStore>
    | ReturnType<typeof setLoading>
    | ReturnType<typeof setError>
    | ReturnType<typeof setAddress>
    | ReturnType<typeof deleteAddress>
    | ReturnType<typeof setAvcResult>
    | ReturnType<typeof setTariffs>
    | ReturnType<typeof setSelectedTariffId>
    | ReturnType<typeof overlayLoaded>
    | ReturnType<typeof openOverlay>
    | ReturnType<typeof closeOverlay>
    | ReturnType<typeof setActiveOverlay>
    | ReturnType<typeof resetTariffsToPreAvc>
    | ReturnType<typeof setHomesPassed>;
